<template>
    <div style="height:auto">
        <!--div class="menu" id="menu"  @mouseover="menushow()" @mouseleave="menuhide()">
            <label class="text-center" style="display:flex; padding: 20px 20px 40px 10px; font-size:30px; color:white">Menu</label>
        </div-->
        <aside class="sidebar" id="sidebar" @mouseleave="menuhide" >
            <div class="text-center">
                <label @click="menuhide" class="fas fa-forward" style="font-size:60px;cursor:pointer"></label>
            </div>
            <v-list class="text-center">
                <v-list-item>
                    <v-list-item-avatar>
                        <v-img  :src="userstorage.photo"></v-img>
                    </v-list-item-avatar>
                </v-list-item>

                <v-list-item link>
                    <v-list-item-content>
                        <v-list-item-title class="title">{{userstorage.username}}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <div id="leftside-navigation">
                <ul class="nano-content">
                    <li  class="sub-menu" style="width:100%">
                        <a href="javascript:void(0);" @click="goprofileuser(userstorage.username)" ><i class="fa fa-user"></i><span>{{language==='English'?'My Profile':'Mi Perfil'}}</span></a>
                    </li>
                    <li  class="sub-menu" style="width:100%">
                        <a href="javascript:void(0);" @click="gotoprojects();menuhide()"><i class="fa fa-folder"></i><span>{{language==='English'?'My Projects':'Mis Proyectos'}}</span></a>
                    </li>
                    <!--v-menu>
                        <v-btn  slot="activator" style="color:#007bff">
                            {{language==='En
                            glish'?'Language':'Idioma'}}
                        </v-btn> 
                        <v-list>
                            <v-list-tile @click="changelanguage(chossinglanguage)" v-for="chossinglanguage in chossinglanguage" :key="chossinglanguage.length">
                                <label>{{chossinglanguage.language}}</label>
                            </v-list-tile>
                        </v-list>
                    </v-menu-->
                    
                    <li style="width:100%">
                        <a @click="logout()" href=""><i class="fas fa-user-times"></i><span>{{language==='English'?'Logout':'Cerrar Sesión'}}</span></a>
                    </li>
                    <v-divider></v-divider>
                    <label style="margin-left:25px">{{language==='English'?'Language':'Idioma'}}</label>
                    <li style="width:100%">
                        <a @click="changelanguage(chossinglanguage);menuhide()" v-for="chossinglanguage in chossinglanguage" :key="chossinglanguage.length"><i :class="chossinglanguage.language==='English'?'fas fa-flag-usa':'fas fa-flag'"></i><span>{{chossinglanguage.language}}</span></a>
                    </li>
                    

                    

                </ul>
            </div>
        </aside>
        <!--nav class="navbar fixed-top navbar-expand-lg navbar-dark bg-dark">
            <a class="navbar-brand" href="/#/">SERVCONSA</a>

            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div  class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul  class="navbar-nav mr-auto">
                    
                    <li v-if="session && user.rol=='Administrador' || user.rol=='Supervisor'" class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        1 Gestor de Usuarios
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" href="/#/Usuarios">Usuarios Sistema</a>
                            <a class="dropdown-item" href="/#/Tecnicos">Técnicos</a>
                        </div>
                    </li>

                    <li v-if="session && user.rol=='Administrador' || user.rol=='Supervisor'" class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        2 Equipos
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" href="/#/Patrones">Patrones</a>
                            <a class="dropdown-item" href="/#/Carga">Cargas Ficticias</a>
                            <a class="dropdown-item" href="/#/Medidores">Medidores Homologados</a>
                        </div>
                    </li>

                    <li v-if="session && user.rol=='Administrador' || user.rol=='Supervisor'" class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        3 Empresas y Semestres
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" href="/#/Empresa">Empresas</a>
                            <a class="dropdown-item" href="/#/EmpServicio">Empresa de Servicios</a>
                            <a class="dropdown-item" href="/#/Semestres">Semestres</a>
                        </div>
                    </li>

                    <li v-if="session" class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        4 Carga Datos
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" href="/#/">Anexo 2</a>
                            <a class="dropdown-item" href="/#/">Anexo 3.1</a>
                        </div>
                    </li>
                    
                    <li v-if="session" class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        5 Contrastes
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" href="/#/Contrastes">Registro de Contrastes</a>
                            <a class="dropdown-item" href="/#/">Seguimiento de Contraste</a>
                            <a class="dropdown-item" href="/#/">Modificación Semestral</a>
                        </div>
                    </li>

                    <li v-if="session" class="nav-item ">
                        <a class="nav-link" href="/#/">6 Validaciones</a>
                    </li>

                    <li v-if="session" class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        7 Reportes
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" href="/#/anexo4d1">Anexo 4.1</a>
                            <a class="dropdown-item" href="/#/">Anexo 5.1</a>
                            <a class="dropdown-item" href="/#/">INACALP</a>
                            <a class="dropdown-item" href="/#/">Informe Emitido Semestral</a>
                        </div>
                    </li>

                    

                </ul>
                    <button v-if="!session" class="btn btn-outline-success my-2 my-sm-0" type="submit" @click="Login()">Inicie Sesión</button>
                    <button v-else class="btn btn-outline-success my-2 my-sm-0" type="submit" @click="logout()">Cerrar Sesión</button>
            </div>
        </nav-->

    </div>

</template>
<script>
import env from '../../../config/env.example'


import { EventBus } from '../../../helpers/eventbus/event-bus'
export default{
    mounted: function() {
        
        this.menuhide()

        EventBus.$on('changelanguage',()=>{
            let choosedlanguage = JSON.parse(localStorage.getItem('language'))
            this.language = choosedlanguage.language
            //console.log(this.language)
            //console.log(choosedlanguage)
        })
        EventBus.$on('showmenu',()=>{
            this.menushow()
        })
       
    },

    data: function() {
        return {
            language: JSON.parse(localStorage.getItem('language')) !== null ? JSON.parse(localStorage.getItem('language')).language : '',
            chossinglanguage:[
                {
                    language: 'English'
                },
                {
                    language: 'Español'
                }
            ],
        }
    },

    props:{
        userstorage:null
    },
    
    methods: {
        changelanguage(language){
            localStorage.setItem('language',JSON.stringify(language))
            EventBus.$emit('changelanguage')
        },
        gotoprojects(){
            this.$router.push('/projects')
        },
        goprofileuser(username){
            window.location = `${env.host}${username}`
        },
        menuhide(){
                document.getElementById("sidebar").style = `
                    transform: translateX(0);
                `
        },
        menushow(){
                    document.getElementById("sidebar").style = `
                        translateX(-100%);
                    `
        },

        logout(){
            EventBus.$emit('logout')
        },
    },
        
        
  }
  

</script>

<style lang="scss">
    
  .sidebar-toggle {
  margin-left: -240px;
}
.sidebar {
    height: 100%;
    width: 100%;
    position: fixed;
    z-index: 2000;
    overflow: auto;
    top: 0;
    left: 100%;
    padding-top: 10px;
    transition: 0.5s;
    background: white;
    -webkit-transition: all .3s ease-in-out;
    -moz-transition: all .3s ease-in-out;
    -o-transition: all .3s ease-in-out;
    -ms-transition: all .3s ease-in-out;
    transition: all .3s ease-in-out;
    z-index: 1000;
  transform: translateX(-100%);
        @media screen and (min-width: 300px) {
            width: 60%;
        }
        @media screen and (min-width: 400px) {
            width: 60%;
        }
        @media screen and (min-width: 500px) {
            width: 45%;
        }
        @media screen and (min-width: 600px) {
            width: 35%;
        }
        @media screen and (min-width: 750px) {
            width: 27%;
        }
        @media screen and (min-width: 850px) {
            width: 25%;
        }
        @media screen and (min-width: 1000px) {
            width: 25%;
        }
        @media screen and (min-width: 1100px) {
            width: 15%;
        }
        @media screen and (min-width: 1300px) {
            width: 13%;
        }
        & a {
            padding: 6px 6px 6px 6px;
            text-decoration: none;
            font-size: 1.2em;
            color: #ffffff;
            display: block;
            margin: 10px 0;
            transition: all 0.5s;
            &:hover {
                background: rgb(67, 67, 67);
                border-radius: 20px;
                text-align: center;
            }
        }
    #leftside-navigation {
    ul, ul ul {
      margin: -2px 0 0;
      padding: 0;
    }
    ul {
      li {
        list-style-type: none;
        border-bottom: 1px solid rgba(255,255,255,.05);
        &.active {
          & > a {
            color: black;
          }
          ul {
            display: block;
          }
        }
        a {
          color: black;
          text-decoration: none;
          display: block;
          padding: 18px 0 18px 25px;
          font-size: 12px;
          outline: 0;
          -webkit-transition: all 200ms ease-in;
          -moz-transition: all 200ms ease-in;
          -o-transition: all 200ms ease-in;
          -ms-transition: all 200ms ease-in;
          transition: all 200ms ease-in;
          &:hover {
            color: #1abc9c;
          }
          span {
            display: inline-block;
          }
          i {
            width: 20px;
            .fa-angle-left, .fa-angle-right {
              padding-top: 3px;
            }
          }
        }
      }
    }
    ul ul {
      display: none;
      li {
        background: black;
        margin-bottom: 0;
        margin-left: 0;
        margin-right: 0;
        border-bottom: none;
        a {
          font-size: 12px;
          padding-top: 13px;
          padding-bottom: 13px;
          color: #aeb2b7;
        }
      }
    }
  }
}
</style>

